import { i18nKeys } from 'translationTypes'
import i18n from '../../../../i18n'

export default {
  headerTitleText: () => i18n.t(i18nKeys.deliveryIssue_header),
  descriptionText: () => i18n.t(i18nKeys.deliveryIssueList_description),
  contractViolationTitle: () => i18n.t(i18nKeys.deliveryIssueList_contractViolation_title),
  contractViolationDescription: () => i18n.t(i18nKeys.deliveryIssueList_contractViolation_description),
  contractViolationSubDescription: () => i18n.t(i18nKeys.deliveryIssueList_contractViolation_subDescription),
  contractViolationExtremelyLateTitle: () => i18n.t(i18nKeys.deliveryIssueList_contractViolation_extremelyLate_title),
  contractViolationNeverArrivedTitle: () => i18n.t(i18nKeys.deliveryIssueList_contractViolation_neverArrived_title),
}
